module.exports = __webpack_public_path__ + "static/media/image_green.102fd5ff.png";